import React from 'react';
import { SubmitButton } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { DownloadIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
// eslint-disable-next-line max-len
import useDownloadAffordaPortalApplicationPDF from '../../../hooks/data-modifying/useDownloadAffordaPortalApplicationPDF';
import useCheckFormExistsQuery from '../../../hooks/data-fetching/useCheckFormExistsQuery';

const DownloadAffordaPortalApplicationPDF = ({ portalUserId, name }) => {
  const { data: formDataExists } = useCheckFormExistsQuery({ portalUserId });
  const {
    mutate: downloadAffordaPortalApplicationPDFMutate,
    isLoading: isDownloadAffordaPortalApplicationPDFLoading,
  } = useDownloadAffordaPortalApplicationPDF();

  return (
    <SubmitButton
      size={'small'}
      variant={'text'}
      endIcon={<DownloadIcon />}
      color={'primary'}
      disabled={!formDataExists}
      onClick={(event) => {
        event.stopPropagation();
        downloadAffordaPortalApplicationPDFMutate({ portalUserId, name });
      }}
      isSubmitting={isDownloadAffordaPortalApplicationPDFLoading}
    >
      Application Details
    </SubmitButton>
  );
};

export default DownloadAffordaPortalApplicationPDF;
